import React, { useState } from 'react'
import { Layout, Tabs } from 'antd'
import { PieChartOutlined, BarChartOutlined, ClockCircleOutlined, LineChartOutlined } from '@ant-design/icons'
import ReportsHeader from './components/ReportsHeader'
import OverviewTab from './components/Tabs/Overview'
import CategoryAnalysisTab from './components/Tabs/CategoryAnalysis'
import ExpiryTrackingTab from './components/Tabs/ExpiryTracking'
import StockTurnoverTab from './components/Tabs/StockTurnover'
import styles from './Reports.module.css'

const { Content } = Layout

const Reports = () => {
  const [activeTab, setActiveTab] = useState('overview')
  const [dateRange, setDateRange] = useState(null)

  const items = [
    {
      key: 'overview',
      label: (
        <span>
          <PieChartOutlined /> Overview
        </span>
      ),
      children: <OverviewTab dateRange={dateRange} />
    },
    {
      key: 'category',
      label: (
        <span>
          <BarChartOutlined /> Category Analysis
        </span>
      ),
      children: <CategoryAnalysisTab dateRange={dateRange} />
    },
    {
      key: 'expiry',
      label: (
        <span>
          <ClockCircleOutlined /> Expiry Tracking
        </span>
      ),
      children: <ExpiryTrackingTab dateRange={dateRange} />
    },
    {
      key: 'turnover',
      label: (
        <span>
          <LineChartOutlined /> Stock Turnover
        </span>
      ),
      children: <StockTurnoverTab dateRange={dateRange} />
    }
  ]

  return (
    <Layout>
      <ReportsHeader dateRange={dateRange} setDateRange={setDateRange} activeTab={activeTab} />
      <Content className={styles.reportsContent}>
        <Tabs activeKey={activeTab} onChange={setActiveTab} items={items} className={styles.reportsTabs} />
      </Content>
    </Layout>
  )
}

export { Reports as InventoryReports }
